import { ReactNode } from "react";
import { Tabs } from "@mantine/core";
import { CustomTable } from "../../../../components/Table/CustomTable";
import { TransactionTypes } from "../../../DataDisplayTable/TransactionTable";
import TransactionTab from "./TransactionTab";
import { ThProps } from "../../../../components/TransactionPage/TransactionPage";
import { RowDataTransaction } from "../../../../components/TransactionPage/types";

export enum ColumnHeaderToFilterPairCash {
    TRANSACTION_ID = "Transaction ID",
    FULLNAME = "Name",
    TYPE = "Type",
    CASH = "Cash",

    CREATED = "Created At",
    REMARK = "Remark",
}

export const colFilterCash = ColumnHeaderToFilterPairCash;
export const colFiltersCash: { [key in ColumnHeaderToFilterPairCash]: string } = {
    [colFilterCash.TRANSACTION_ID]: "transaction_id",
    [colFilterCash.FULLNAME]: "fullname",
    [colFilterCash.TYPE]: "type",
    [colFilterCash.CASH]: "cash",
    [colFilterCash.CREATED]: "createdAt",

    [colFilterCash.REMARK]: "remarks",
};

class CashTab extends TransactionTab {

    constructor(sortBy: keyof RowDataTransaction | null, setSorting: { (field: keyof RowDataTransaction): void }, Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }, rowDataTransaction: RowDataTransaction[] | null) {
        super(sortBy, setSorting, Th, rowDataTransaction)
    }

    create(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]): ReactNode {
        return (
            <Tabs.Panel value={TransactionTypes.CASH}>
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPairCash)}
                    filters={Object.values(colFilterCash)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={this.sortBy}
                    setSorting={this.setSorting}
                    customclasses={classes}
                    Th={this.Th}
                    rowData={this.rowDataTransaction}
                    rows={rows}
                />
            </Tabs.Panel>
        )
    }

}

export default CashTab